import moment from "moment";

export function taxCalculatation(taxes, amount) {
  let taxrate = 0;
  let perAmount = 0;

  if (taxes) {
    taxes.forEach((tax) => {
      taxrate += tax.amount;
      if (amount != undefined) {
        perAmount += (tax.amount * parseFloat(amount.toFixed(2))) / 100;
      }
    });
  } else {
    taxrate = undefined;
    perAmount = undefined;
  }

  if (amount != undefined) {
    return perAmount;
  } else {
    return taxrate;
  }
}


export const generateToken = () => {
  const header = {
    alg: "HS256",
    typ: "JWT",
  };

  const payload = {
    exp: Math.floor(Date.now() / 1000) + 60 * 60, // Token expires in 1 hour
    iat: Math.floor(Date.now() / 1000), // Issued at
    user: "exampleUser", // Example user data
  };

  const base64Encode = (obj) => {
    return btoa(
      JSON.stringify(obj)
        .replace(/=/g, "") // Remove padding
        .replace(/\+/g, "-") // Replace '+' with '-'
        .replace(/\//g, "_") // Replace '/' with '_'
    );
  };

  const headerEncoded = base64Encode(header);
  const payloadEncoded = base64Encode(payload);

  // Mock signature (not cryptographically secure)
  const signature = "mockSignature";

  return `${headerEncoded}.${payloadEncoded}.${signature}`;
};


function CurrencyFormatter(value, locale, currency) {
  if (value == null || isNaN(value)) {
    console.error("Invalid value passed to CurrencyFormatter:", value);
    return "Invalid Value"; // Return a fallback string
  }

  return value.toLocaleString(locale ? locale : "en-US", {
    style: "currency",
    currency: currency ? currency : "USD",
  });
}

 const getCurrency = () => {
  return localStorage.getItem("Currency") ? localStorage.getItem("Currency") : "₹";
};


function TimeFormatter(value, locale) {
  // later switch to session storage
  let time = new Date(value).toLocaleTimeString(locale ? locale : "en-US");
  return time;
}

function DateFormatter(value, locale) {
  // later switch to session storage
  let date = new Date(value).toLocaleDateString(locale ? locale : "en-US");

  return moment(date).format('DD-MM-YYYY');
}


function convertToISO(dateInput) {
  // Check if dateInput is provided, otherwise use the current date
  const date = dateInput ? new Date(dateInput) : new Date();
  return date.toISOString(); // Outputs: "yyyy-MM-ddTHH:mm:ss.SSSZ"
}


function convertISOToDDMMYYYY(isoDate) {
  return moment(isoDate).format('DD-MM-YYYY');
}

function getEndTime(startTime, durationMinutes) {
  const [hours, minutes] = startTime.split(':').map(Number);
  const end = new Date(0, 0, 0, hours, minutes + durationMinutes);
  return `${end.getHours().toString().padStart(2, '0')}:${end.getMinutes().toString().padStart(2, '0')}`;
}


export const calculatePaymentAmounts = (grandTotal = 0, advancePercentage = 0) => {
  const total = Number(Number(grandTotal || 0).toFixed(2));
  const advance = Number(advancePercentage || 0);
  const remaining = 100 - advance;

  const advanceAmount = Number(((total * advance) / 100).toFixed(2));
  const remainingAmount = Number(((total * remaining) / 100).toFixed(2));

  return {
    total,
    advancePercentage: advance,
    remainingPercentage: remaining,
    advanceAmount,
    remainingAmount,
  };
};


// export const countDaysBetweenDates = () => {
//   let checkInLocal = localStorage.getItem("checkInDate")
//   let checkOutLocal = localStorage.getItem("checkOutDate")


//   if (!checkInLocal || !checkOutLocal) return 0;

//   // Convert to Date objects
//   const checkIn = new Date(checkInLocal);
//   const checkOut = new Date(checkOutLocal);

//   // Normalize to local date only (remove time)
//   const localCheckIn = new Date(checkIn.getFullYear(), checkIn.getMonth(), checkIn.getDate());
//   const localCheckOut = new Date(checkOut.getFullYear(), checkOut.getMonth(), checkOut.getDate());

//   const timeDiff = localCheckOut - localCheckIn;

//   const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

//   return dayDiff > 0 ? dayDiff : 0; // Ensure non-negative
// };

export const countDaysBetweenDates = () => {
  const checkInLocal = localStorage.getItem("checkInDate");

  if (!checkInLocal) return 0;

  // Convert to Date object
  const checkIn = new Date(checkInLocal);

  // Normalize both dates to local midnight (no time portion)
  const today = new Date();
  const localToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const localCheckIn = new Date(checkIn.getFullYear(), checkIn.getMonth(), checkIn.getDate());

  // Difference in milliseconds
  const timeDiff = localCheckIn - localToday;

  // Convert to days
  const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  return dayDiff > 0 ? dayDiff : 0; // Prevent negative values
};


// Here's a modified version of your function that:

// Takes a dynamic number of days (e.g., 45) as input.

// Compares today's date with the selected check-in date.

// Returns true if the check-in date is within the given number of days from today.

// Optionally returns the number of days between today and check-in.


// export const isCheckInWithinDays = (daysLimit) => {

//   const limit = daysLimit ? daysLimit :  40

//   const checkInLocal = localStorage.getItem("checkInDate");

//   if (!checkInLocal) return { isWithinRange: false, daysUntilCheckIn: 0 };

//   const checkIn = new Date(checkInLocal);

//   const today = new Date();
//   const localToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
//   const localCheckIn = new Date(checkIn.getFullYear(), checkIn.getMonth(), checkIn.getDate());

//   const timeDiff = localCheckIn - localToday;
//   const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

//   const isWithinRange = dayDiff > 0 && dayDiff <= limit;

//   return {
//     isWithinRange,
//     daysUntilCheckIn: dayDiff > 0 ? dayDiff : 0,
//   };
// };


export const isCheckInWithinDays = (daysLimit) => {
  const limit = daysLimit ?? 40;

  const checkInLocal = localStorage.getItem("checkInDate");

  if (!checkInLocal) return { isWithinRange: false, daysUntilCheckIn: 0 };

  const checkIn = new Date(checkInLocal);
  const today = new Date();

  // Normalize both to remove time portion
  const localToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const localCheckIn = new Date(checkIn.getFullYear(), checkIn.getMonth(), checkIn.getDate());

  // Milliseconds difference
  const timeDiff = localCheckIn.getTime() - localToday.getTime();

  // Calculate difference in days (no ceil)
  const dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  // console.log('insideDaysLimit3::: ', dayDiff);

  const isWithinRange = dayDiff < 0 ? true  :  dayDiff >= 0 && dayDiff < limit


  return {
    isWithinRange,
    daysUntilCheckIn: dayDiff >= 0 ? dayDiff : 0,
  };
};









export { CurrencyFormatter,getCurrency , DateFormatter, TimeFormatter, convertToISO , convertISOToDDMMYYYY ,getEndTime };
